import getScenarioStore from '../selectors/getScenarioStore';
import { mutator } from 'satcheljs';
import { updateIsSuggestionSetCompleteInternal } from '../actions/internalActions';

export default mutator(updateIsSuggestionSetCompleteInternal, actionMessage => {
    const currentSuggestions = getScenarioStore(actionMessage.scenarioId).currentSuggestions;
    currentSuggestions.IsComplete = actionMessage.isComplete;
});
